import { useEffect } from "react";
import LegalLayout from "@/components/LegalLayout";
import { AlertTriangle } from "lucide-react";

const DisclaimerPage = () => {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <LegalLayout title="Important Disclaimer" lastUpdated="February 2026">
      {/* Prominent Warning */}
      <div className="bg-amber-50 border-2 border-amber-200 rounded-xl p-6 mb-8">
        <div className="flex items-start gap-4">
          <AlertTriangle className="w-8 h-8 text-amber-500 flex-shrink-0 mt-1" />
          <div>
            <h2 className="text-xl font-bold text-amber-800 mb-2">
              Entertainment & Novelty Purpose Only
            </h2>
            <p className="text-amber-700 font-medium">
              LoBe certificates are created purely for <strong>entertainment and novelty purposes</strong>. 
              They have absolutely no legal validity and are not official documents of any kind.
            </p>
          </div>
        </div>
      </div>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          Nature of LoBe Certificates
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          LoBe certificates are:
        </p>
        <ul className="list-disc list-inside text-[#5A5A5A] space-y-2">
          <li><strong>For Entertainment Only:</strong> Designed as fun, novelty items</li>
          <li><strong>Non-Official:</strong> They are NOT government or legally recognized documents</li>
          <li><strong>Non-Binding:</strong> They carry absolutely no legal weight or obligations</li>
          <li><strong>Novelty Items:</strong> Created for amusement and fun purposes only</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          What LoBe Certificates Are NOT
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          Our certificates cannot and should not be used as:
        </p>
        <ul className="list-disc list-inside text-[#5A5A5A] space-y-2">
          <li>Proof of marriage, engagement, or civil union</li>
          <li>Legal documentation for any purpose whatsoever</li>
          <li>Evidence in any legal proceedings</li>
          <li>Official records for government or institutional use</li>
          <li>Replacement for any legally binding agreements</li>
          <li>Documentation for immigration, visa, or official purposes</li>
          <li>Proof of any relationship status</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          User Acknowledgment
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          By using LoBe, you acknowledge and agree that:
        </p>
        <ul className="list-disc list-inside text-[#5A5A5A] space-y-2">
          <li>You understand these certificates are purely for entertainment and novelty</li>
          <li>You will NOT attempt to use certificates for any legal or official purposes</li>
          <li>You will NOT misrepresent the nature of these certificates to others</li>
          <li>You take full responsibility for how you use and share your certificate</li>
          <li>You understand LoBe has no legal validity whatsoever</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          No Professional Advice
        </h2>
        <p className="text-[#5A5A5A]">
          LoBe does not provide legal, financial, or professional advice of any kind. 
          These certificates are novelty items for entertainment purposes only. 
          If you need official documentation for your relationship, please consult 
          with qualified legal professionals in your jurisdiction.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          Questions?
        </h2>
        <p className="text-[#5A5A5A]">
          If you have questions about the nature of our certificates, please contact us at{" "}
          <a href="mailto:support@lobe.love" className="text-[#E8A0BF] hover:underline">
            support@lobe.love
          </a>
        </p>
      </section>
    </LegalLayout>
  );
};

export default DisclaimerPage;
